// src/components/VersatileComponents/SmallScreenMessage.js

import { createTheme } from "@mui/material";
import { useMemo, useContext } from "react"; // <-- Import useContext
import { themeSettings } from "../../utils/theme";
import { useCustomTheme } from "../../contexts/ThemeContext";
import AuthContextProvider from "../../contexts/AuthContext";
// <-- Import your AuthContext

const SmallScreenMessage = () => {
  // Get the current user from the AuthContext
  // const { currentUser } = useContext(AuthContextProvider);

  const { mode } = useCustomTheme();
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const screentxtStyle = theme.palette.mode === "dark" ? "#B1B1B1" : "#292727";

  // Screen size restriction disabled for mobile accessibility
  // All users can now access the application on mobile devices
  return null;
};

export default SmallScreenMessage;
